import * as React from "react";
import { Route } from 'react-router-dom';
import { VehicleDatabaseList } from './VehicleDatabase';
import Payment from "./Payment";
import ChangePassword from "./ChangePassword";
// import Controllers from "./Controllers";
import ControllerEdit from "./ControllerEdit";
import ControllerCreate from "./ControllerCreate";
import ParkingProfile from "./parkingProfile";
import UpdateParkingProfileUser from "./updateParkingProfileUser";
import UpdateParkingProfileInfo from "./updateParkingProfileInfo";
import ParkingMapView from './parkingsMapView'
// import OnBoardUsers from "./onBoardUsers"
import ParkingAnalytics from './parkingAnalyticV3';
import VehicleSummaryRedirect from './vehicleSummaryRedirect';
import CreateSubUser from "./createSubUser";
import DashboardInsights from "./dashboardInsights";
import Resource from "./components/Resource";
import ContactUs from "./ContactUs";
import { VahanInvoiceDetails } from "./VahanAPIBilling";
import { PermitInvoiceDetails } from "./PermitUsersBilling";
import BulkPermitsOnboarding  from "./bulkPermitsOnboarding";
import GracePeriodConfig from "./gracePeriodConfigurations";
import { GracePeriodLogs } from "./gracePeriodLogs";

const customRoutes = [
    <Route exact path="/vehicleDatabase" component={VehicleDatabaseList} />,
    <Route exact path="/payment" component={Payment} />,
    <Route exact path="/changePassword" component={ChangePassword} />,
    // <Route exact path="/controllers" component={Controllers} />,
    <Route exact path="/controller/edit/:id" component={ControllerEdit} />,
    <Route exact path="/controllers/create" component={ControllerCreate} />,
    <Route exact path="/parking/profile" component={ParkingProfile} />,
    <Route exact path="/parking/profile/user" component={UpdateParkingProfileUser} />,
    <Route exact path="/parking/profile/info/:id" component={UpdateParkingProfileInfo} />,
    <Route exact path="/mapview" component={ParkingMapView} />,
    <Route exact path="/bulkPermitsOnboarding" component={BulkPermitsOnboarding} />,
    <Route exact path="/parkingAnalytics" component={ParkingAnalytics} />,
    <Route exact path="/vehicleSummary" component={VehicleSummaryRedirect} />,
    <Route exact path="/createSubUser" component={CreateSubUser} />,
    <Route exact path="/dashboardInsights" component={DashboardInsights} />,
    <Route exact path="/resources" component={Resource}/>,
    <Route exact path="/contactUs" component={ContactUs}/>,
    <Route exact path="/invoices/vaahan-api/:id" component={VahanInvoiceDetails} />,
    <Route exact path="/invoices/user-permit/:id" component={PermitInvoiceDetails} />,
    <Route exact path="/gracePeriod/configurations" component={GracePeriodConfig} />,
    <Route exact path="/gracePeriod/logs" component={GracePeriodLogs} />
];
export default customRoutes;